import React, { useState, useEffect } from 'react';
import { ApiService } from '../services/api';
import './Footer.css';

const Footer = () => {
  const [companyData, setCompanyData] = useState({
    companyName: '',
    address: '',
    mobile: '',
    email: '',
    wxQrCode: '',
    sphQrCode: '',
    xhsQrCode: ''
  });

  // 获取公司详情
  useEffect(() => {
    const fetchCompanyDetail = async () => {
      try {
        const response = await ApiService.getCompanyDetail();
        
        if (response.code === '0000' && response.data) {
          setCompanyData({
            companyName: response.data[0].companyName || '',
            address: response.data[0].address || '',
            mobile: response.data[0].mobile || '',
            email: response.data[0].email || '',
            wxQrCode: response.data[0].wxQrCode || '',
            sphQrCode: response.data[0].sphQrCode || '',
            xhsQrCode: response.data[0].xhsQrCode || ''
          });
        }
      } catch (error) {
        console.error('获取公司详情失败:', error);
        // 使用默认值
        setCompanyData({
          companyName: '',
          address: '',
          mobile: '',
          email: '',
          wxQrCode: '',
          sphQrCode: '',
          xhsQrCode: ''
        });
      }
    };

    fetchCompanyDetail();
  }, []);
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>联系我们</h3>
            <div className="contact-info">
              <p>{companyData.companyName}</p>
              <p>{companyData.address}</p>
              <p>业务咨询：{companyData.mobile}</p>
              <p>商务合作：{companyData.email}</p>
            </div>
          </div>
          

          <div className="footer-section">
            <h3>关注我们</h3>
            <div className="social-links">
              <div className="qr-code">
                {companyData.wxQrCode ? (
                  <img src={companyData.wxQrCode} alt="微信公众号二维码" className="qr-image" />
                ) : (
                  <div className="qr-placeholder">📱</div>
                )}
                <p>官方微信公众号</p>
              </div>
              <div className="qr-code">
                {companyData.sphQrCode ? (
                  <img src={companyData.sphQrCode} alt="视频号二维码" className="qr-image" />
                ) : (
                  <div className="qr-placeholder">📺</div>
                )}
                <p>视频号</p>
              </div>
              <div className="qr-code">
                {companyData.xhsQrCode ? (
                  <img src={companyData.xhsQrCode} alt="小红书二维码" className="qr-image" />
                ) : (
                  <div className="qr-placeholder">📖</div>
                )}
                <p>小红书</p>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-links">
            <a
              href="#top"
              onClick={(e) => {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
            >
              回到顶部
            </a>
          </div>
          <div className="copyright">
            <p>版权所有 © {companyData.companyName}</p>
            <p>京ICP备2025146936号</p>
            <p>本网站由阿里云提供云计算及安全服务 | 本网站支持 IPv6</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
